import React, { useEffect, useState } from 'react';
import './PageLoader.css';

const PageLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        const diff = Math.random() * 30;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="page-loader">
      <div className="loader-progress-bar">
        <div 
          className="loader-progress-fill" 
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="loader-content">
        <div className="loader-animation">
          {/* Animated boxes representing cargo/packages */}
          <div className="cargo-container">
            <div className="cargo-box box-1"></div>
            <div className="cargo-box box-2"></div>
            <div className="cargo-box box-3"></div>
          </div>
          {/* Moving line representing transportation */}
          <div className="transport-line"></div>
        </div>
        <div className="loader-text-container">
          <div className="loader-text">Loading</div>
          <div className="loader-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
